
import { Link } from 'react-router-dom';

const newProducts = [
  {
    id: 9,
    name: 'سيروم الهيالورونيك المرطب',
    category: 'العناية بالبشرة',
    price: 279,
    rating: 4.8,
    reviews: 87,
    image: 'https://public.readdy.ai/ai/img_res/a0805fe1865ed963a7ba5333207c9a00.jpg'
  },
  {
    id: 10,
    name: 'كريم الأساس السائل',
    category: 'المكياج',
    price: 219,
    rating: 4.7,
    reviews: 124,
    image: 'https://readdy.ai/api/search-image?query=luxury%20liquid%20foundation%20bottle%20on%20soft%20pink%20background%2C%20elegant%20makeup%20product%20photography%2C%20minimalist%20beauty%20aesthetic%2C%20professional%20cosmetic%20display%2C%20rose%20gold%20accents&width=500&height=600&seq=new2&orientation=portrait'
  },
  {
    id: 11,
    name: 'زيت الشعر بالأرغان',
    category: 'العناية بالشعر',
    price: 189,
    rating: 4.9,
    reviews: 156,
    image: 'https://readdy.ai/api/search-image?query=luxury%20argan%20hair%20oil%20bottle%20on%20soft%20pink%20background%2C%20elegant%20beauty%20product%20photography%2C%20minimalist%20aesthetic%2C%20professional%20cosmetic%20display%2C%20feminine%20and%20clean%20style&width=500&height=600&seq=new3&orientation=portrait'
  },
  {
    id: 12,
    name: 'بادي ميست بالفانيليا',
    category: 'العطور',
    price: 159,
    rating: 4.6,
    reviews: 93,
    image: 'https://readdy.ai/api/search-image?query=luxury%20vanilla%20body%20mist%20spray%20bottle%20on%20soft%20pink%20background%2C%20elegant%20fragrance%20product%20photography%2C%20minimalist%20beauty%20aesthetic%2C%20professional%20display%2C%20feminine%20style&width=500&height=600&seq=new4&orientation=portrait'
  }
];

const NewArrivals = () => {
  return (
    <section className="py-20 bg-white" dir="rtl">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-800 mb-3" style={{ fontFamily: 'Playfair Display, serif' }}>
            أحدث الإضافات
          </h2>
          <p className="text-gray-600">اكتشفي أحدث منتجاتنا الحصرية</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-product-shop>
          {newProducts.map((product) => (
            <div
              key={product.id}
              className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300"
            >
              <div className="relative overflow-hidden">
                <Link to={`/product/${product.id}`} className="block">
                  <div className="relative w-full h-80 overflow-hidden">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                </Link>
                
                <span className="absolute top-3 right-3 bg-emerald-400 text-white text-xs px-3 py-1.5 rounded-full font-medium">
                  جديد
                </span>
              </div>

              <div className="p-5">
                <p className="text-xs text-rose-400 font-medium mb-2">{product.category}</p>
                <Link to={`/product/${product.id}`}>
                  <h3 className="text-base font-semibold text-gray-800 mb-2 hover:text-rose-400 transition-colors line-clamp-2">
                    {product.name}
                  </h3>
                </Link>
                
                <div className="flex items-center gap-2 mb-3">
                  <div className="flex items-center gap-1">
                    <i className="ri-star-fill text-amber-400 text-sm"></i>
                    <span className="text-sm font-medium text-gray-700">{product.rating}</span>
                  </div>
                  <span className="text-xs text-gray-400">({product.reviews} تقييم)</span>
                </div>

                <div className="flex items-center justify-between">
                  <span className="text-lg font-bold text-gray-800">{product.price} ر.س</span>
                  <button className="w-9 h-9 flex items-center justify-center bg-rose-400 text-white rounded-full hover:bg-rose-500 transition-colors cursor-pointer">
                    <i className="ri-shopping-cart-line text-base"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewArrivals;
